import React, { FC, useRef, useState } from 'react';
import Image from 'components/image/Image';
import { JobCardActionEnum } from 'core/enum/jobCardAction';
import { getDateFormatter } from 'helpers/dateConverter';
import { STAGE_TYPES } from 'core/constants/jobCardConstant';
import { MenuItem, Select } from '@material-ui/core';

import './Index.scss';
import { useNavigate } from 'react-router';
import { DynamicActionButton } from 'components/newButtons/DynamicActionButton';
import StatusIcon from 'components/newButtons/StatusIcon';
import { IndustryList } from 'components/IndustryList';
import { JobService } from 'services/jobs/job';
import { clampText } from 'helpers/sharedFunctions';
import useLocales from 'hooks/useLocales';

const actions = {
  pending: [
    JobCardActionEnum.ACCEPT,
    JobCardActionEnum.CANCEL,
    JobCardActionEnum.MORE_INFO
  ],
  accepted: [JobCardActionEnum.PROFILE_VIEW, JobCardActionEnum.MORE_INFO]
};

const IncomingRequests: FC<any> = ({
  id,
  name,
  sub_title,
  email,
  icon,
  score,
  culture_score,
  date,
  responded_at,
  industry,
  stage,
  setOpen,
  status,
  cancel,
  candidateId,
  isCandidate,
  jobId,
  acceptRequest,
  declineRequest,
  jobTitle
}): JSX.Element => {
  const { t } = useLocales();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [showIndustries, setShowIndustries] = useState(false);
  const industriesBtnRef = useRef<HTMLSpanElement>(null);

  const value = STAGE_TYPES.find((el: any) => el.value === stage);
  const currentActions = status === 2 ? actions.accepted : actions.pending;

  const handleStageChange = async (id: number, value: any) => {
    await JobService.manageJob(id, { stage: value });
  };

  return (
    <div className="IRCard" style={{ position: 'relative' }}>
      <div
        className="IRCard__left"
        style={{
          width: isCandidate ? '400px' : '450px'
        }}
      >
        <div onClick={() => setOpen(jobId || id, 'incoming-requests')}>
          <Image
            url={icon}
            name={!icon ? 'no-avatar.svg' : ''}
            className={
              isCandidate
                ? 'IRCard__left-image-candidate'
                : 'IRCard__left-image'
            }
            objectFit="cover"
          />
        </div>
        <div className="IRCard__left__info">
          <div className="IRCard__left__info_name">
            <div className="IRCard__left__info-name-container">
              <span className="IRCard__left__info-title">{name || email}</span>
              <span className="IRCard__left__info-job-title">{jobTitle}</span>
            </div>
            {industry && (
              <IndustryList
                industry={industry}
                showIndustries={showIndustries}
                setShowIndustries={setShowIndustries}
                industriesBtnRef={industriesBtnRef}
              />
            )}
          </div>
          <span className="IRCard__left__info-sub">
            {clampText(sub_title, 45)}
          </span>
          {!isCandidate && status === 2 ? (
            <Select
              className="IRCard__left__info-status"
              defaultValue={value?.value}
              onChange={(e) => handleStageChange(id, e.target.value)}
              onClose={() => setIsOpen(false)}
              onOpen={() => setIsOpen(true)}
              onClick={() => setIsOpen(!isOpen)}
              IconComponent={() => (
                <>
                  <Image
                    className={`down-arrow ${isOpen ? 'active' : ''}`}
                    name="down-arrow-white.svg"
                  />
                </>
              )}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {STAGE_TYPES?.map((el: any) => (
                <MenuItem value={el.value} key={el.value}>
                  {el.to_show}
                </MenuItem>
              ))}
            </Select>
          ) : (
            !isCandidate && (
              <span className="new_application">{t('New application')}</span>
            )
          )}
        </div>
      </div>
      <div className="IRCard__middle">
        <div className="IRCard__middle__percents">
          <span className="IRCard__middle__matches-title">
            {' '}
            {score || 0}% {t('Talent Match')}
          </span>
          <span className="IRCard__middle__matches-title">
            {culture_score || 0}% {t('Cultural Fit')}
          </span>
        </div>
      </div>
      <div className="IRCard__middle">
        <div className="IRCard__middle__percents"></div>
        <div className="IRCard__middle__details">
          <div className="IRCard__middle__details__item">
            <span className="IRCard__middle__details__item-title">
              {t(isCandidate ? 'Message send on' : 'Applied on')}
            </span>
            <span className="IRCard__middle__details__item-desc">
              {getDateFormatter(date, 'MMM DD YYYY, h:mm a')}
            </span>
          </div>

          <div className="IRCard__middle__details__item">
            {responded_at && (
              <>
                <span className="IRCard__middle__details__item-title">
                  {t('Response on')}:
                </span>
                <span className="IRCard__middle__details__item-desc">
                  {getDateFormatter(responded_at, 'MMM DD YYYY, h:mm a')}
                </span>{' '}
              </>
            )}
          </div>
        </div>
      </div>
      <div className="IRCard__right">
        <div className="IRCard__right__actions">
          {!isCandidate && status === 0 && (
            <>
              <DynamicActionButton
                label={t('Accept')}
                backgroundColor="#0fb398"
                onClick={() => acceptRequest && acceptRequest(id)}
              />
              <DynamicActionButton
                label={t('Decline')}
                backgroundColor="red"
                onClick={() => declineRequest && declineRequest(id)}
              />
            </>
          )}
          {isCandidate && status === 1 && (
            <>
              <DynamicActionButton
                label={t('Accept')}
                backgroundColor="#0fb398"
                onClick={() => acceptRequest && acceptRequest(id)}
              />
              <DynamicActionButton
                label={t('Decline')}
                backgroundColor="red"
                onClick={() => declineRequest && declineRequest(id)}
              />
            </>
          )}
          {currentActions.map((action, index) => (
            <React.Fragment key={index}>
              {action === JobCardActionEnum.MORE_INFO && status !== 2 && (
                <DynamicActionButton
                  label={t('More Info')}
                  backgroundColor="#BEA0E5"
                  onClick={() => setOpen(jobId || id, 'incoming-requests')}
                />
              )}

              {action === JobCardActionEnum.PROFILE_VIEW &&
                status === 2 &&
                !isCandidate &&
                candidateId && (
                  <DynamicActionButton
                    label={t('Profile')}
                    backgroundColor="#A0D5E5"
                    onClick={() => navigate(`/view-profile/${candidateId}`)}
                  />
                )}

              {action === JobCardActionEnum.MORE_INFO && status === 2 && (
                <DynamicActionButton
                  label={t('More Info')}
                  backgroundColor="#BEA0E5"
                  onClick={() => setOpen(jobId || id, 'teaser-view')}
                />
              )}
            </React.Fragment>
          ))}
        </div>
        <div className="IRCard__right__status">
          {status === 2 && <StatusIcon status="accepted" />}
          {status === 4 && <StatusIcon status="rejected" />}
          {(status === 0 || status === 1) && !isCandidate && (
            <StatusIcon status="no-response" />
          )}
          {status === 3 && <StatusIcon status="rejected" />}
        </div>
      </div>
    </div>
  );
};

export default IncomingRequests;
